<template>
  <Component
    :is="maxSmall ? DrawerClose : DialogClose"
    :asChild="asChild"
    :class="{ 'pointer-events-none': disabled }"
  >
    <slot />
  </Component>
</template>

<script setup>
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { DialogClose } from "@/Shadcn/Components/ui/dialog";
import { DrawerClose } from "@/Shadcn/Components/ui/drawer";

defineProps({
  asChild: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

const { maxSmall } = useBreakpoints();
</script>
